'use strict';

import React, { Fragment, useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CGUModal from 'Modals/CGUModal';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import TextInput from 'Components/Forms/Elements/TextInput';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import LinkedInButton from 'Pure/LinkedInButton';
import GoogleButton from 'Pure/GoogleButton';
import Loader from 'Pure/Loader';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
export default function RegistrationForm(props) {
  const [loading, setLoading] = useState(false);
  const [exists, setExists] = useState(false);
  const [form, setForm] = useState({});
  const [linkedin_redirecting, setLinkedInRedirecting] = useState(false);
  const [google_redirecting, setGoogleRedirecting] = useState(false);
  const [status_messages, setStatusMessages] = useState({});
  const [status, setStatus] = useState({});
  const [cgu_modal, setCGUModal] = useState({});
  const loader = loading === true ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['white', 'bg-blue']
  }) : undefined;
  const area_3rd_party = props['with-linkedin'] || props['with-google'] ? /*#__PURE__*/React.createElement("div", {
    className: "registration-form__3rd-party"
  }, props['with-linkedin'] ? /*#__PURE__*/React.createElement(LinkedInButton, {
    bemit: ['blue', 'registration-3rd-party'],
    onClick: e => signInWithThirdParty(e, 'linkedin'),
    loading: linkedin_redirecting,
    text: "S'inscrire avec LinkedIn"
  }) : undefined, props['with-google'] ? /*#__PURE__*/React.createElement(GoogleButton, {
    onClick: e => signInWithThirdParty(e, 'google'),
    loading: google_redirecting,
    text: "S'inscrire avec Google",
    bemit: ['registration-3rd-party']
  }) : undefined) : undefined;
  const output = /*#__PURE__*/React.createElement("form", {
    method: "POST",
    action: action('Register'),
    className: "registration-form"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: form['user[login]'],
    name: "user[login]",
    type: "text",
    label: "E-mail (login)",
    autocomplete: "new-email",
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: form['user[password]'],
    name: "user[password]",
    type: "password",
    label: "Mot de passe (12c. minimum)",
    autocomplete: "new-password",
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: form['user[lastname]'],
    name: "user[lastname]",
    label: "Nom",
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: form['user[firstname]'],
    name: "user[firstname]",
    label: "Pr\xE9nom",
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: handleChange,
    className: bemit('c-form-element') + ' u-margin-top-15 custom-checkbox',
    value: form['user[cgu]'],
    name: "user[cgu]",
    "full-width": false,
    status: status_messages,
    label: "J'ai lu et accepte les "
  }, /*#__PURE__*/React.createElement(Button, {
    className: 'u-margin-left-5 ' + bemit('c-link', ['cgu']),
    onClick: e => setCGUModal({
      open: true,
      trg: e?.target
    })
  }, "Conditions de Vente et d'annulation"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: handleChange,
    className: bemit('c-form-element'),
    value: form['user[newsletter]'],
    name: "user[newsletter]",
    label: "J'accepte de recevoir des offres commerciales et/ou publicitaires de myWO par email, sms et mms.",
    "full-width": false,
    status: status_messages
  }))), exists ? undefined : getFormStatus(status, ['v2']), props['wallet-redirections'] && exists === true ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['red'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, "Votre compte a d\xE9j\xE0 \xE9t\xE9 cr\xE9\xE9 avec succ\xE8s. Veuillez vous connecter pour continuer.")), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: e => props.requestLoginForm({
      login: form['user[login]'],
      password: form['user[password]']
    }),
    className: bemit('c-flat-btn', ['front', 'blue'])
  }, /*#__PURE__*/React.createElement("span", {
    className: "c-arrow-btn__text"
  }, "Me connecter"))) : undefined, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['front', 'blue'].concat(exists === true ? ['disabled'] : [])) + ' u-block u-margin-auto u-margin-top-30',
    onClick: validate,
    disabled: exists === true
  }, "Valider l'inscription", loader), props['with-google'] || props['with-linkedin'] ? /*#__PURE__*/React.createElement("div", {
    className: "c-separator c-separator--light\r u-margin-top-30 u-margin-bottom-30"
  }, "ou") : undefined, area_3rd_party, /*#__PURE__*/React.createElement(CGUModal, {
    onClose: e => setCGUModal({}),
    open: cgu_modal.open === true,
    trigger_src: cgu_modal.trg
  }));
  return output;
  function handleChange({
    e,
    value,
    name
  }) {
    setForm({
      ...form,
      [name]: value
    });
    setExists(false);
    setStatus({});
    setStatusMessages({
      ...status_messages,
      [name]: undefined
    });
  }
  async function validate(e) {
    if (loading === true) return;
    setLoading(true);
    let sent_data = {
      ...form
    };
    if (props['include-etablishment-slug']) {
      sent_data.etablishment_slug = window.location.pathname.split('/')[2];
    }
    try {
      var response = await ajaxRequest(action('Register'), {
        data: sent_data
      });
    } catch (e) {
      setLoading(false);
      const {
        status_messages,
        E_CODE,
        ...status
      } = e;
      setExists(E_CODE === 'EXISTS');
      setStatusMessages(status_messages);
      return setStatus(status);
    }
    setLoading(false);
    if (typeof props.onRegistration === 'function') {
      props.onRegistration(response);
    }
  }
  function signInWithThirdParty(e, strategy) {
    if (isTrue(form['user[cgu]']) === false) {
      return setStatus({
        error: 'Veuillez accepter les conditions pour continuer.'
      });
    }
    if (strategy === 'google') {
      setGoogleRedirecting(true);
    } else {
      setLinkedInRedirecting(true);
    }
    window.setTimeout(function () {
      let new_url = [document.location.origin, action('PassportAuth'), '?source=' + (props.source || 'RegistrationForm'), '&register=true', '&strategy=' + strategy].join('');
      if (isTrue(form['user[newsletter]'])) {
        new_url += '&newsletter=true';
      }
      document.location.href = new_url;
    }, 320);
  }
}
